// extracted by mini-css-extract-plugin
module.exports = {"container":"SchoolMentorPopup_container__292u0","content":"SchoolMentorPopup_content__qmJu7","footer":"SchoolMentorPopup_footer__2fhL2"};